/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_InfoInputs */

const es_tools_legajox_info = /** @type {(inputs: Tools_Legajox_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo información de Legajox...`)
};

const en_tools_legajox_info = /** @type {(inputs: Tools_Legajox_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Legajox info...`)
};

/**
* | output |
* | --- |
* | "Getting Legajox info..." |
*
* @param {Tools_Legajox_InfoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_info = /** @type {((inputs?: Tools_Legajox_InfoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_InfoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_info(inputs)
	return en_tools_legajox_info(inputs)
});
export { tools_legajox_info as "tools.legajox.info" }